import { useEffect, useRef, useState } from 'react';

import { ActualSizeTabName, SIZE_TAB } from '../services/actual-size/types';

interface UseSizeInfoTabOptions {
  /** 구매내역 데이터 존재 여부 (undefined: 로딩 중) */
  hasPurchaseData?: boolean;
  /** 유저 사이즈 정보 존재 여부 (undefined: 로딩 중) */
  hasUserSizeData?: boolean;
}

export const useSizeInfoTab = (
  isSizeComparable: boolean,
  isLoggedIn: boolean,
  options?: UseSizeInfoTabOptions,
) => {
  const { hasPurchaseData, hasUserSizeData } = options ?? {};
  const isInitializedRef = useRef(false);

  const [activeTab, setActiveTab] = useState<ActualSizeTabName>(SIZE_TAB.DIRECT_INPUT);

  // 데이터 로드 후 탭 재설정
  useEffect(() => {
    // 비교 불가능하거나 비로그인이면 스킵
    if (!isSizeComparable || !isLoggedIn) return;

    // 이미 초기화됐으면 스킵 (사용자 탭 클릭 후에는 재설정하지 않음)
    if (isInitializedRef.current) return;

    // 두 데이터 모두 로딩 완료될 때까지 스킵
    if (hasPurchaseData === undefined || hasUserSizeData === undefined) return;

    // 탭 결정 로직 (우선순위):
    // 1. 내가 입력한 사이즈가 있으면 → 직접 입력 탭 (최우선)
    // 2. 내가 입력한 사이즈 없고, 구매내역 있으면 → 구매내역 탭
    // 3. 둘 다 없으면 → 직접 입력 탭 (기본값)
    if (hasUserSizeData) {
      setActiveTab(SIZE_TAB.DIRECT_INPUT);
    } else if (hasPurchaseData) {
      setActiveTab(SIZE_TAB.MY_PURCHASE);
    } else {
      setActiveTab(SIZE_TAB.DIRECT_INPUT);
    }

    isInitializedRef.current = true;
  }, [isSizeComparable, isLoggedIn, hasPurchaseData, hasUserSizeData]);

  const onTabClick = (tab: ActualSizeTabName) => {
    if (!isSizeComparable) return;
    setActiveTab(tab);
  };

  return { activeTab, onTabClick };
};
